import React, { useEffect, useState } from "react";
import './activeMember.css';
import HeaderComponent from "../header/header";
import NavbarComponent from "../header/top.navbar";
import FooterComponent from "../footer/footer";
import { Helmet } from "react-helmet-async";
import { getActiveMemberDetails } from "../../services/master.service";

const ActiveMemberComponent = () => {
  const [activeMemberDetails, setActiveMemberDetails] = useState(null);
  const [groupedMembers, setGroupedMembers] = useState({});
  const [loading, setLoading] = useState(true);
  const [activeType, setActiveType] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const subscribedUserDetails = await getActiveMemberDetails();

        const sortedUsers = [...subscribedUserDetails].sort((a, b) => {
          const numA = parseInt(a.membershipNo?.match(/\d+/)?.[0] || "0", 10);
          const numB = parseInt(b.membershipNo?.match(/\d+/)?.[0] || "0", 10);
          return numA - numB;
        });

        setActiveMemberDetails(sortedUsers);

        const order = [
          "Life Fellow",
          "Life Senior Member",
          "Life Member",
          "Annual Member",
          "Annual Student Member",
          "Unknown"
        ];

        if (sortedUsers && sortedUsers.length > 0) {
          const grouped = sortedUsers.reduce((acc, user) => {
            const type = user.membershipName || "Unknown";
            if (!acc[type]) acc[type] = [];
            acc[type].push(user);
            return acc;
          }, {});


          const orderedGrouped = {};
          order.forEach((type) => {
            if (grouped[type]) {
              orderedGrouped[type] = grouped[type];
            }
          });

          // Add any unknown/new types at the end
          Object.keys(grouped).forEach((type) => {
            if (!order.includes(type)) {
              orderedGrouped[type] = grouped[type];
            }
          });
          setGroupedMembers(orderedGrouped);
        } else {
          setGroupedMembers({});
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setGroupedMembers({});
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);


  useEffect(() => {
    if (groupedMembers && Object.keys(groupedMembers).length > 0) {
      setActiveType(Object.keys(groupedMembers)[0]);
    }
  }, [groupedMembers]);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedMembers = activeType && groupedMembers[activeType]
    ? groupedMembers[activeType].slice(startIndex, endIndex)
    : [];
  const totalPages = activeType && groupedMembers[activeType]
    ? Math.ceil(groupedMembers[activeType].length / itemsPerPage)
    : 0;

  const renderDesktopTables = () => {
    if (!groupedMembers || Object.keys(groupedMembers).length === 0) {
      return (
        <div className="d-none d-md-block"> {/* Desktop only */}
          <table className="member-table" style={{ tableLayout: 'fixed', width: '100%' }}>
            <thead>
              <tr>
                <th className="memberHeader">SN</th>
                <th className="memberHeader">Name</th>
                <th className="memberHeader">Email</th>
                <th className="memberHeader">Membership No</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="4" style={{ textAlign: 'center', padding: '20px' }}>
                  No active members available
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

    return (
      <div className="d-none d-md-block">
        {/* Nav Tabs */}
        <ul className="nav nav-tabs mb-2">
          {Object.keys(groupedMembers).map((type) => (
            <li className="nav-item navItemMember" key={type}>
              <button
                className={`nav-link navMember ${activeType === type ? 'active' : ''}`}
                onClick={() => {
                  setActiveType(type);
                  setCurrentPage(1);
                }}
              >
                {type}
              </button>
            </li>
          ))}
        </ul>

        {/* Table for active type */}
        {activeType && groupedMembers[activeType] && (
          <div className="member-table-wrapper shadow-card">
            <div className="table-responsive">
              <table className="member-table" style={{ tableLayout: 'fixed', width: '100%' }}>
                <colgroup>
                  <col style={{ width: '50px' }} />
                  <col style={{ width: '200px' }} />
                  <col style={{ width: '250px' }} />
                  <col style={{ width: '150px' }} />
                </colgroup>
                <thead>
                  <tr>
                    <th className="memberHeader">SN</th>
                    <th className="memberHeader">Name</th>
                    <th className="memberHeader">Email</th>
                    <th className="memberHeader">Membership No</th>
                  </tr>
                </thead>
                <tbody>
                    {paginatedMembers.map((user, index) => (
                      <tr key={index}>
                        <td className="text-center">{startIndex + index + 1}</td>
                        <td>{user.name || 'N/A'}</td>
                        <td>{user.email || 'N/A'}</td>
                        <td>{user.membershipNo || 'N/A'}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
              <div className="d-flex justify-content-between align-items-center mt-3 px-2 mb-2">
                  <span className="text-muted">
                    Page {currentPage} of {totalPages}
                  </span>
                  <nav>
                    <ul className="pagination mb-0">
                      <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>Previous</button>
                      </li>
                      {[...Array(totalPages)].map((_, i) => {
                          const page = i + 1;
                          const isActive = currentPage === page;

                          if (
                            page === 1 ||
                            page === totalPages ||
                            (page >= currentPage - 1 && page <= currentPage + 1)
                          ) {
                            return (
                              <li key={page} className={`page-item ${isActive ? 'active' : ''}`}>
                                <button className="page-link" onClick={() => setCurrentPage(page)}>{page}</button>
                              </li>
                            );
                          }

                          if (
                            (page === currentPage - 2 && page !== 2) ||
                            (page === currentPage + 2 && page !== totalPages - 1)
                          ) {
                            return <li key={page}><span className="page-link">...</span></li>;
                          }

                          return null;
                        })}
                      <li className={`page-item ${currentPage === Math.ceil(groupedMembers[activeType].length / itemsPerPage) ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>Next</button>
                      </li>
                    </ul>
                  </nav>
               </div>

            </div>
          </div>
        )}
      </div>
    );
  };

  const renderMobileCards = () => (
    <div className="active-member-mobile-cards">
      {groupedMembers && Object.keys(groupedMembers).length > 0 ? (
        Object.entries(groupedMembers).map(([type, members]) => (
          <div key={type} className="active-member-section">
            <h2 className="active-member-heading">{type}</h2>
            {members.map((user, index) => (
              <div className="active-member-user-card" key={index}>
                <div className="active-member-card-row">
                  <div className="active-member-card-label">Name</div>
                  <div className="active-member-card-value">{user.name || 'N/A'}</div>
                </div>
                <div className="active-member-card-row">
                  <div className="active-member-card-label">Email</div>
                  <div className="active-member-card-value">{user.email || 'N/A'}</div>
                </div>
                <div className="active-member-card-row">
                  <div className="active-member-card-label">Membership No</div>
                  <div className="active-member-card-value">{user.membershipNo || 'N/A'}</div>
                </div>
              </div>
            ))}
            <br />
          </div>
        ))
      ) : (
        <div className="no-data">No active members available</div>
      )}
    </div>
  );


  return (
    <>
      <Helmet>
        <title>ACTIVE MEMBERS SMARTFORUM - Society for Microwaves, Antennas and Radar Technologies</title>
        <meta name="description" content="Join SMART, a technology-driven community shaping the future of innovation, research, and collaboration." />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <HeaderComponent />
      <NavbarComponent />
      <section id="fixed-sub-nav" className="gradient-background" style={{ paddingBottom: '30px', paddingTop: '30px' }}>


        <div className="activeMembers-container  mb-4">
          <div className="row activeMembers-row ">
            <h1 className="activeMembers-main-title">SMART Active Members</h1>

            <div className="activeMembers-sections-wrapper">
              {loading ? (
                <div className="no-data">Loading data...</div>
              ) : (
                <>
                  {renderDesktopTables()}
                  {renderMobileCards()}
                </>
              )}
            </div>
          </div>

        </div>
      </section>

      <FooterComponent />


    </>
  );
};

export default ActiveMemberComponent;
